module.exports = __webpack_public_path__ + "static/commission_screenshot-f3602cd52e77aeacc11277aa168ae42c.png";